<template>
  <file-upload :accept="acceptType" :multiple="true" :limit="9" :on-success="handleSuccess" v-if="isEditor">
    <div class="upload-file__btn">上传文件</div>
  </file-upload>
  <div class="upload-file__list">
    <div class="upload-file__item flex flex-item-center" v-for="(item, index) in fileNames" :key="index">
      <div class="upload-file__item-name line1">{{ item }}</div>
      <i class="iconfont icon-close" @click="handleClose(index)" />
    </div>
  </div>
</template>
<script>
import { computed, defineComponent, ref, watch } from 'vue'
import fileUpload from '@/components/upload/file-upload.vue'
import { baseProps, controlItemManage } from '../control-web/index'
export default defineComponent({
  name: 'f-multiple',
  inheritAttrs: false,
  components: { fileUpload },
  props: { ...baseProps, modelValue: { type: String } },
  emits: ['update:modelValue', 'my-change'],
  setup(props, context) {
    const fileList = ref([]) //文件列表
    const { value, mySubmit } = controlItemManage(props, context)
    const handleSuccess = (res) => {
      fileList.value.push(res.data.url)
      let str = fileList.value.join(',')
      emits('update:modelValue', str)
      mySubmit(str)
    }
    const handleClose = (index) => {
      fileList.value.splice(index, 1)
    }
    // 文件名称列表
    const fileNames = computed(() => {
      return fileList.value.map((i) => {
        return i.split('/').pop() || i
      })
    })
    const acceptType = ref(
      '.jpeg,.jpg,.gif,.png,.webp,.ico,.mp4,.webm,.ts,.avi,.mov,.wmv,.m4v,.pdf,.ppt,.txt,.xls,.xlsx,.doc,.docx'
    )
    watch(
      () => value.value,
      (newVal) => {
        if (newVal && newVal !== '') {
          fileList.value = newVal?.split(',')
        } else {
          fileList.value = []
        }
      },
      { immediate: true }
    )
    return {
      value,
      mySubmit,
      handleSuccess,
      fileNames,
      handleClose,
      acceptType
    }
  }
})
</script>
<style lang="less" scoped>
.upload-file {
  &__btn {
    height: 32px;
    width: 88px;
    color: #ffffff;
    background-color: #409eff;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 32px;
    text-align: center;
  }
  &__list {
    margin: 12px 0;
  }
  &__item {
    width: 80%;
    font-size: 14px;
    color: #606266;
    margin-bottom: 5px;
    padding: 0 5px;
    &:hover {
      background-color: #f5f7fa;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  &__item-name {
    width: calc(100% - 26px);
    margin-right: 12px;
    &:hover {
      color: #409eff;
      text-decoration: underline;
      text-decoration-color: #409eff;
    }
  }
}
</style>
